<template>
     <div class="exercises-index"> 
          <v-tabs centered background-color="transparent">
                <v-tab @click="$inertia.visit('/backoffice/exercises')">Exercises</v-tab>
                <v-tab @click="$inertia.visit('/backoffice/workouts')">Workouts</v-tab>
                <v-tab @click="$inertia.visit('/backoffice/programs')">Programs</v-tab>
            </v-tabs>
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Exercises" }}</h2>
            </div>
            <div class="right">
                <new-exercise :categories="categories"></new-exercise>
            </div>
        </div>

        <div class="table-container">
            <v-data-table
            :headers="headers"
            :items="exercises.data"
            :server-items-length="exercises.total"
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
            item-key="id"
            checkbox-color="primary"
            :page="exercises.current_page"
            :options.sync="options"
            :items-per-page="options.itemsPerPage"
            mobile-breakpoint="0"
            :footer-props="{
                    'items-per-page-options': [5, 10, 25, 50]
                }"
            >
                <template v-slot:item.name="{ item }">
                    {{ item.name }} 
                </template>
                <template v-slot:item.category="{ item }">
                    {{ item.category != null ? item.category.name : '' }}
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn @click="openUpdatePeriodModal(item)" :id="'update' + item.id" v-show="$page.props.p['members.manage']" icon>
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip :activator="'#update'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.edit_exercise || "Edit exercise"}}</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn :id="'delete' + item.id" icon class="delete-icon">
                        <v-icon>mdi-trash-can-outline</v-icon>
                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.delete_exercises || "Delete exercise"}}</span>
                        </v-tooltip>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
import AppLayout from '@/js/Layouts/AppLayout'
import NewExercise from './Components/NewExercise'

export default {
    layout: AppLayout,
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Exercises"
        }
    },
    components: {
        NewExercise
    },
    props:{
        exercises: Object,
        categories: Array,
        lang: Object     
    },
    data(){
        return {
            headers: [
                {text: this.lang.name || 'Name', value: 'name', align: 'start'},
                {text: this.lang.type || 'Category', value: 'category'},
                {text: '', value: 'action', sortable: false, align: 'end'}
            ],
            options:{
                page: this.exercises.current_page, 
                itemsPerPage: this.exercises.per_page
            },
        }
    },
    
    methods:{

    }
}
</script>
